import http from "./http";

export const GetCategories = async (params = {}) => {
    return await http.get("/categories", { params });
};
